import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import Typewriter from '../common/Typewriter';

const tags = ['Web', 'Brand', 'Apps', 'Marketing'];

const Hero = () => {
  return (
    <>
      <section id="home" className="relative flex h-[100svh] items-center justify-center overflow-hidden bg-black px-6">
        <div className="mx-auto max-w-3xl text-center">
          <div className="mb-6 inline-flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            {tags.map((tag) => (
              <span key={tag} className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.14em] text-white">
                <span className="h-1.5 w-1.5 bg-white" />
                {tag}
              </span>
            ))}
          </div>

          <h1 className="text-[44px] leading-[0.95] text-white sm:text-6xl md:text-7xl">
            <span className="sr-only">
              Empowering Businesses locally, nationwide, and globally with Digital Solutions
            </span>
            <span aria-hidden="true">
              <span className="block">Empowering Businesses</span>
              <span className="block">
                <Typewriter
                  words={['locally', 'nationwide', 'globally']}
                  colors={['#1DB954', '#1DB954', '#1DB954']}
                />
              </span>
              <span className="block">with Digital Solutions</span>
            </span>
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-[#d0d0d0] md:text-base">
            Web Development, Branding, App Development – All in One Studio
          </p>

          <a href="#contact" className="solid-button mt-8">
            Let's Create Something Amazing
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </section>
    </>
  );
};

export default Hero;
